import React from 'react';
import { Section } from './ui/Section';
export function HowToUse() {
  return <Section data-id="element-101">
      <div className="text-center mb-16" data-id="element-102">
        <h2 className="text-3xl md:text-4xl font-bold text-stone-900 mb-6" data-id="element-103">
          Cómo se usa (en la vida real)
        </h2>
      </div>

      <div className="relative max-w-4xl mx-auto" data-id="element-104">
        {/* Connecting Line */}
        <div className="absolute left-1/2 top-0 bottom-0 w-0.5 bg-stone-200 -ml-px hidden md:block" data-id="element-105"></div>

        <div className="grid md:grid-cols-2 gap-12" data-id="element-106">
          {/* Day 1 */}
          <div className="relative md:text-right md:pr-12" data-id="element-107">
            <div className="absolute right-0 top-6 w-4 h-4 rounded-full bg-amber-500 border-4 border-white shadow-sm -mr-2 hidden md:block" data-id="element-108"></div>
            <div className="bg-white p-8 rounded-2xl shadow-sm border border-stone-100 relative z-10" data-id="element-109">
              <span className="inline-block px-3 py-1 bg-amber-100 text-amber-800 rounded-full text-sm font-bold mb-4" data-id="element-110">
                Día 1
              </span>
              <h3 className="text-xl font-bold text-stone-900 mb-4" data-id="element-111">
                Configuración y Rutinas
              </h3>
              <ul className="space-y-3 md:justify-end" data-id="element-112">
                <li className="text-stone-600" data-id="element-113">Pegas tu Prompt Base</li>
                <li className="text-stone-600" data-id="element-114">Haces Rutina 1 (prioridades)</li>
                <li className="text-stone-600" data-id="element-115">Haces Rutina 2 (mensajes)</li>
              </ul>
            </div>
          </div>

          {/* Day 2 */}
          <div className="relative md:pl-12 md:mt-24" data-id="element-116">
            <div className="absolute left-0 top-6 w-4 h-4 rounded-full bg-stone-400 border-4 border-white shadow-sm -ml-2 hidden md:block" data-id="element-117"></div>
            <div className="bg-white p-8 rounded-2xl shadow-sm border border-stone-100 relative z-10" data-id="element-118">
              <span className="inline-block px-3 py-1 bg-stone-100 text-stone-800 rounded-full text-sm font-bold mb-4" data-id="element-119">
                Día 2
              </span>
              <h3 className="text-xl font-bold text-stone-900 mb-4" data-id="element-120">
                Práctica y Ajuste
              </h3>
              <ul className="space-y-3" data-id="element-121">
                <li className="text-stone-600" data-id="element-122">Haces Rutina 3 (decisiones)</li>
                <li className="text-stone-600" data-id="element-123">Guardas tus 10 prompts</li>
                <li className="text-stone-600" data-id="element-124">
                  Ajustas tu tono para que suene a ti
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="text-center mt-16" data-id="element-125">
          <p className="text-xl font-medium text-stone-800 bg-amber-50 inline-block px-8 py-4 rounded-xl border border-amber-100" data-id="element-126">
            Listo: ya tienes una "caja de herramientas" para siempre.
          </p>
        </div>
      </div>
    </Section>;
}